
import popular1 from '../../asset/images/popular-01.jpg'
import popular2 from '../../asset/images/popular-02.jpg'
import popular3 from '../../asset/images/popular-03.jpg'
import popular4 from '../../asset/images/popular-04.jpg'
import popular5 from '../../asset/images/popular-05.jpg'
import popular6 from '../../asset/images/popular-06.jpg'
import popular7 from '../../asset/images/popular-07.jpg'
import popular8 from '../../asset/images/popular-08.jpg'

import live1 from '../../asset/images/stream-01.jpg'
import live2 from '../../asset/images/stream-02.jpg'
import live3 from '../../asset/images/stream-03.jpg'
import live4 from '../../asset/images/stream-04.jpg'

import prof1 from '../../asset/images/avatar-01.jpg'
import prof2 from '../../asset/images/avatar-02.jpg'
import prof3 from '../../asset/images/avatar-03.jpg'
import prof4 from '../../asset/images/avatar-04.jpg'


const MostPopularData = [
    { id: 'MostPopular1', image: popular1, name: 'Fortnite', kind: 'Sandbox', rate: '4.8', download: '2.4m', },
    { id: 'MostPopular2', image: popular2, name: 'PubG', kind: 'Battle', rate: '4.2', download: '3.8m' },
    { id: 'MostPopular3', image: popular4, name: 'Fortnite', kind: 'Legendary', rate: '2.6', download: '4.5m' },
    { id: 'MostPopular4', image: popular5, name: 'Eagles Fly', kind: 'Matrix Games', rate: '3.8', download: '6.4m' },
    { id: 'MostPopular5', image: popular3, name: 'Dota2', kind: 'Stream-X', rate: '3.8', download: '5.2m' },
    { id: 'MostPopular6', image: popular6, name: 'Mini Craft', kind: 'Legendary', rate: '3.9', download: '2.8m' },
    { id: 'MostPopular7', image: popular7, name: 'Warface', kind: 'Max 3D', rate: '4.8', download: '4.2m' },
    { id: 'MostPopular8', image: popular8, name: 'Warcraft', kind: 'Legend', rate: '3.6', download: '4.8m' },
]

const MostPopularBrowseData = [
    { id: 'Mostlive1', image: live1, profile: prof1, caption: 'KenganC', detail: 'Live Streaming Till Morning' },
    { id: 'Mostlive2', image: live2, profile: prof2, caption: 'LunaMa', detail: 'Maybe Nathej Allnight Chillin\'' },
    { id: 'Mostlive3', image: live4, profile: prof3, caption: ' Areluwa', detail: 'CS-GO 36 Hours Live Stream' },
    { id: 'Mostlive4', image: live3, profile: prof4, caption: 'GangTm', detail: 'Just Talking With Fans' },
]

export default MostPopularData
export { MostPopularBrowseData }

